var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carousel-container"},[_c('VueSlickCarousel',_vm._b({ref:"carousel",staticClass:"carousel",attrs:{"dots":true},on:{"afterChange":_vm.pictureChanged}},'VueSlickCarousel',_vm.settings,false),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }